const pages = [
  {
    id: 'overview',
    label: 'סקירה',
    description: 'מבט מהיר',
    icon: 'overview',
  },
  {
    id: 'places',
    label: 'מקומות',
    description: 'רשימה ועריכה',
    icon: 'places',
  },
  {
    id: 'appUsers',
    label: 'משתמשים',
    description: 'משתמשי האפליקציה',
    icon: 'users',
  },
  {
    id: 'reports',
    label: 'דיווחים',
    description: 'כל דיווחי העומס',
    icon: 'reports',
  },
  {
    id: 'placeIssues',
    label: 'דיווחי מקום',
    description: 'תקלות ועדכוני מידע',
    icon: 'issues',
  },
  {
    id: 'analytics',
    label: 'אנליטיקס',
    description: 'אירועים וסינונים',
    icon: 'analytics',
  },
];

const icons = {
  overview: <><rect x="3" y="3" width="7" height="7" rx="2" /><rect x="14" y="3" width="7" height="7" rx="2" /><rect x="3" y="14" width="7" height="7" rx="2" /><rect x="14" y="14" width="7" height="7" rx="2" /></>,
  places: <><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
  users: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>,
  reports: <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" /><path d="M8 7h8M8 11h6" /></>,
  issues: <><path d="M10.3 2.9 1.8 17a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 2.9a2 2 0 0 0-3.4 0Z" /><path d="M12 9v4M12 17h.01" /></>,
  analytics: <><path d="M3 3v18h18" /><path d="m7 16 4-5 4 3 5-7" /></>,
};

const NavIcon = ({ name }) => (
  <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {icons[name]}
  </svg>
);

const AppLayout = ({ activeTab, onTabChange, user, onLogout, children }) => {
  const initials = (user?.name || 'L').trim().slice(0, 2).toUpperCase();
  return (
    <main className="dashboard" dir="rtl">
      <aside className="sidebar">
        <div className="sidebar-top">
          <div className="brand">
            <span className="brand-mark">L</span>
            <div>
              <h2>Calmpi</h2>
              <p className="muted">ניהול מערכת</p>
            </div>
          </div>
          <nav className="side-nav" aria-label="ניווט ראשי">
            {pages.map((page) => (
              <button
                key={page.id}
                className={activeTab === page.id ? 'active' : ''}
                onClick={() => onTabChange(page.id)}
              >
                <NavIcon name={page.icon} />
                <span className="nav-copy">
                  <span>{page.label}</span>
                  <small>{page.description}</small>
                </span>
              </button>
            ))}
          </nav>
        </div>
        <div className="sidebar-account">
          <span className="avatar">{initials}</span>
          <span className="account-copy"><strong>{user?.name}</strong><small>{user?.email || 'מנהל מערכת'}</small></span>
          <button className="logout-button" onClick={onLogout} aria-label="יציאה מהמערכת" title="יציאה">↗</button>
        </div>
      </aside>
      <section className="content">{children}</section>
    </main>
  );
};
export default AppLayout;
